import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { AppInitService } from '../../services/app-init.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<LogoutComponent>,
    private appInitService: AppInitService
  ) {
    if (!this.appInitService?.appConfig?.showLogOutConfirmation) {
      this.exit();
    }
  }

  ngOnInit(): void {
    console.log();
  }
  exit(): void {
    //this.router.navigate(['/login']);
    this.authenticationService.logout();
    this.dialogRef.close(true);
  }
}
